var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-cta-teacher"},[_c('AppButton',_vm._b({class:_vm.classBtn,attrs:{"tag":_vm.tag,"text":_vm.text},scopedSlots:_vm._u([{key:"icon-right",fn:function(){return [_c('AppIcon',{attrs:{"name":"human-male-board","size":"medium"}})]},proxy:true}])},'AppButton',_vm.link,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }